import { useEffect, useLayoutEffect, useRef } from 'react';

export const isEqual = (a, b, _depth = 0) => {
  if (_depth > 50) return false;
  if (Object.is(a, b)) return true;
  if (a == null || b == null) return false;
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) return false;
    return a.every((v, i) => isEqual(v, b[i], _depth + 1));
  }
  if (typeof a === 'object') {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    return keysA.every((key) => isEqual(a[key], b[key], _depth + 1));
  }
  return false;
};

export const useDeepCompareEffect = (effect, deps, depsEqual = isEqual) => {
  const ref = useRef<any>(undefined);

  if (!ref.current || !depsEqual(deps, ref.current)) {
    ref.current = deps;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, ref.current);
};

export const useDeepCompareLayoutEffect = (effect, deps, depsEqual = isEqual) => {
  const ref = useRef<any>(undefined);

  if (!ref.current || !depsEqual(deps, ref.current)) {
    ref.current = deps;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(effect, ref.current);
};
